<template>
  <div class="imgLocalswap" >
    <img
      class="mainlocalimage"
      v-for="p in sortData()"
      :key="p.id"
      :src="p.srcImg"
      :id="p.id"
      :ordby="p.orderBy"
    />
  </div>
</template>

<script>
export default {
  props: {
    listArray: {
      type: Array,
      required: true,
    },
  },
  methods: {
    sortData() {
      return this.listArray.sort((a, b) => a.orderBy - b.orderBy);
    },
  },
};
</script>

<style scoped>
.imgLocalswap {
  border: 1px solid #ffffff;
  line-height: 0;
  text-align: center;
  margin-top: 1px;
  margin-bottom: 1px;
  margin-left: 0px;
  margin-right: 0px;
  position: relative;
}

.mainlocalimage {
 width: 169px;
 height: 50px;
 margin-right: 7px;
}
</style>
